/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */
import InfiniteScroll from "react-infinite-scroll-component";

import {
  FunnelIconCircle,
  IconRoute,
  SearchEdit,
  SearchPriceSearch,
  PricesTableCircleIcon,
  SimulatorsCircleIcon,
  PranchetaCircleIcon,
} from "~misc/icons";

import { Link, useNavigate } from "react-router-dom";
import { initialPath } from "~misc/paths";
import Loader from "~components/Form/components/Loader";

import useHeader from "~components/Header/hooks/useHeader";
import useSearchList from "../hooks/useSearchList";

import "./styles.scss";
import ModalIniciarVisita from "~pages/RouteOptimizationV2/components/Modal/ModalIniciarVisita";
import { useEffect, useMemo, useState } from "react";
import { Spinner } from "@chakra-ui/react";
import { cpfOrCnpjMask } from "~hooks/useHelpers";
import useParametros from "~/fetchs/useParametros";
import useUsuario from "~/fetchs/useUsuario";
import useVisita from "~fetchs/Roterizacao/useVisita";
import useUltimaVisitaMap from "~fetchs/useUltimaVisita";

import ModalRespondeRota from "~components/Modal/ModalResponseRota";
import ModalResponseRota from "~components/Modal/ModalResponseRota";
import LoaderFull from "~components/Form/components/LoaderFull";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";

const scheduleFeatureHydration = (callback) => {
  if (typeof globalThis !== "undefined" && typeof globalThis.requestIdleCallback === "function") {
    return globalThis.requestIdleCallback(callback);
  }

  return globalThis.setTimeout(callback, 120);
};

const cancelFeatureHydration = (taskId) => {
  if (typeof globalThis !== "undefined" && typeof globalThis.cancelIdleCallback === "function") {
    globalThis.cancelIdleCallback(taskId);
    return;
  }

  globalThis.clearTimeout(taskId);
};

const WalletVisitModals = ({ modalOpen, modalResponse, idClient, setLoading, closeModal, closeResponse }) => {
  const navigate = useNavigate();
  const { visitarRota, checkin } = useVisita({ idClient, setLoading });

  const consultar = () => {
    navigate(`/roteirizacao/consulta/${idClient}`);
  };

  return (
    <>
      <ModalResponseRota
        isOpen={modalResponse}
        title={
          <>
            Já existe uma visita em andamento!
            <br />
            Deseja finalizar e iniciar uma nova?
          </>
        }
        finalizar={() => {
          navigate(`${initialPath}/roteirizacao/${checkin.clienteId}`);
        }}
        iniciar={() => {
          visitarRota();
        }}
        onClose={closeResponse}
      />

      {modalOpen && (
        <ModalIniciarVisita
          isOpen={modalOpen}
          id={idClient}
          onClose={closeModal}
          onConfirm={visitarRota}
          onConsult={consultar}
          onCancel={closeModal}
          mensagem="O que deseja fazer?"
        />
      )}
    </>
  );
};

const SearchList = ({ items, value, skip, take, setSkip, total, hideOthersButtons, loadingRequest, isQueryPending = false }) => {
  const { isLoading, loadMoreItems, montaEndereco, renderTagContent, scrollToTop } = useSearchList(skip, setSkip, take, (items || []).length, total);

  const { path } = useHeader();
  const [modalOpen, setModalOpen] = useState(false);
  const [idClient, setIdClient] = useState(null);
  const { getBotoesCliente, parametros } = useParametros();
  const { usuario } = useUsuario();
  const [loader, setLoading] = useState(false);
  const { checkin } = useCheckIn();
  const featureHydrated = true;

  function visitar(item) {
    setIdClient(item);
    setModalOpen(true);
  }

  const closedModal = () => {
    setModalOpen(false);
  };

  const [modalResponse, setModalResponse] = useState(false);

  const clientes = useMemo(() => {
    const temAcesso = (slug) => !!usuario?.slugAcessos?.includes(slug);

    return (items || []).map((item) => {
      const clienteBase = {
        ...item,
        endereco: item.endereco ? montaEndereco(item.endereco) : "",
        tag: renderTagContent(item),
      };

      if (!featureHydrated) {
        return clienteBase;
      }

      return {
        ...clienteBase,
        roteirizacao: getBotoesCliente(item?.trilha?.nome, "roteirizacao") && temAcesso("acesso-ao-menu-de-rota-do-dia"),
        simuladorEnsacados: getBotoesCliente(item?.trilha?.nome, "simulador de ensacados") && temAcesso("acesso-ao-menu-de-simuladores"),
        pesquisa: getBotoesCliente(item?.trilha?.nome, "pesquisa") && temAcesso("acesso-ao-menu-pesquisa-de-preco"),
        tabelaPreco: getBotoesCliente(item?.trilha?.nome, "tabela de preco") && temAcesso("acesso-ao-menu-de-tabela-de-precos"),
        funilObras: getBotoesCliente(item?.trilha?.nome, "funil de obras") && temAcesso("acesso-ao-menu-de-funil-de-obras"),
        formularios:
          getBotoesCliente(item?.trilha?.nome, "formularios") &&
          temAcesso("acesso-ao-menu-de-gestao-de-pesquisas") &&
          temAcesso("acesso-ao-menu-de-rota-do-dia"),
      };
    });
  }, [items, featureHydrated, parametros, usuario?.slugAcessos]);

  const clienteIds = useMemo(() => (items || []).map(i => i?.id).filter(Boolean), [items]);
  const ultimaVisitasMap = useUltimaVisitaMap(clienteIds);

  const queryParams = "?origem=carteira-geral";
  return (
    <>
      {loader && (
        <div className="flex items-center justify-center w-full p-8 z-100">
          <LoaderFull />
        </div>
      )}
      <InfiniteScroll
        dataLength={(clientes || []).length}
        next={loadMoreItems}
        hasMore={!isQueryPending && clientes && (clientes || []).length < total}
        loader={isLoading && <Loader />}
        className={["wallet-search-list", path == `${initialPath}/carteira` ? "wrap-buttons" : ""].join(" ")}
      >
        <div className="container content">
          <div className="container flex items-center justify-between my-4">
            <p className="flex-shrink-0 hidden md:block">
              {typeof total === "number" && total > 0 && (
                <>
                  Exibindo {(clientes || []).length < total ? (clientes || []).length : total} de {total}
                </>
              )}
            </p>

            <p className="flex items-center gap-2 text-sm">
              {loadingRequest && (
                <>
                  <Spinner size={"sm"} />
                  Verificando se há atualizações na carteira
                </>
              )}
            </p>
          </div>

          {clientes?.length == 0 && isQueryPending ? (
            <div className="flex items-center justify-center pt-10">
              <Spinner size={"xl"} thickness="4px" />
            </div>
          ) : clientes?.length == 0 && value?.length > 0 ? (
            <div className="text-center mt-10 text-2xl font-bold">
              Nenhum resultado encontrado com: <span className="text-[red]">"{value}"</span>
            </div>
          ) : (
            clientes?.map((item, index) => (
              <div key={index} className="card-item" data-test-id="client-search-card">
                {path != `${initialPath}/carteira/prospect` && (
                  <>
                    {path === `/carteira` ? (
                      (item.tag || item.bloqueado === true) && (
                        <div className="flex gap-x-2 class flags">
                          {item.tag && <div className={"card-tag" + (item.tag === "Prospect" ? " !bg-secundaria" : "")}>{item.tag}</div>}
                          {item.bloqueado === true && <div className="card-tag card-tag-bloq">Bloqueado</div>}
                        </div>
                      )
                    ) : (
                      item.tag && (
                        <div className="flex gap-x-2 class flags">
                          <div className="card-tag">{item.tag}</div>
                        </div>
                      )
                    )}
                  </>
                )}

                <div className="card-content">
                  <h3 className="card-title">
                    {item?.codigo || item?.codigoProspect || ""} {item.razao ?? item.nome}
                  </h3>

                  <div className="card-description">
                    <p>
                      CPF/CNPJ: <b className="bold">{cpfOrCnpjMask(item.documento)}</b>
                    </p>

                    <p>
                      Segmento Desc.: <b className="bold">{item.segmento}</b>
                    </p>

                    <p>
                      Grupo Centralizador:{" "}
                      <b className="bold">
                        {item.grupoCentralizador ? item.grupoCentralizador : "Sem Grupo Centralizador"}
                      </b>
                    </p>

                    <p>
                      Endereço: <b className="bold">{item.endereco}</b>
                    </p>
                    {item.nomeObra?.trim() && (
                      <p>
                        Nome da Obra: <b className="bold">{item.nomeObra}</b>
                      </p>
                    )}
                    {ultimaVisitasMap?.[item.id] && (
                      <p>
                        Data da última visita: <b className="bold">{ultimaVisitasMap[item.id]}</b>
                      </p>
                    )}
                  </div>
                </div>

                <div className="card-buttons-container">
                  {!hideOthersButtons && item.formularios && (
                    <Link
                      className="card-button"
                      to={`${initialPath}/gestao-de-pesquisa/formularios/${item.id}${queryParams}`}
                    >
                      <PranchetaCircleIcon />
                      <p className="label">Formulários</p>
                    </Link>
                  )}

                  {!hideOthersButtons &&
                    (item?.trilha?.codigo == "420" || item?.trilha?.codigo == "400") &&
                    item.pesquisa && (
                      <Link className="card-button" to={`${initialPath}/pesquisa-de-preco/${item.id}`}>
                        <SearchPriceSearch />
                        <p className="label">Pesquisa</p>
                      </Link>
                    )}

                  {!hideOthersButtons && item.tabelaPreco && (
                    <Link
                      className="card-button"
                      to={`${initialPath}/tabela-preco/${item.id}`}
                      data-test-id="link-price-table"
                    >
                      <PricesTableCircleIcon />
                      <p className="label">Tabela de Preço</p>
                    </Link>
                  )}

                  {!hideOthersButtons && item.funilObras && ["IMO", "INFRA"].includes(item?.trilha?.nome) && (
                    <Link className="card-button" to={`${initialPath}/funil-de-obras/${item.id}/mapeamento`}>
                      <FunnelIconCircle />
                      <p className="label">Funil de obras</p>
                    </Link>
                  )}

                  {!hideOthersButtons && item?.microrregiaoId && item.simuladorEnsacados && (
                    <Link className="card-button" to={`${initialPath}/simuladores/simulacoes/${item.id}`}>
                      <SimulatorsCircleIcon />
                      <p className="label">Simulador</p>
                    </Link>
                  )}

                  {!hideOthersButtons &&
                    (item?.trilha?.codigo == "420" ||
                      item?.trilha?.codigo == "400" ||
                      item?.trilha?.codigo == "410" ||
                      item?.trilha?.codigo == "430") &&
                    item.roteirizacao && (
                      <div
                        className="card-button"
                        onClick={() => {
                          if (checkin) {
                            setModalResponse(true);
                            setIdClient(item.id);
                          } else {
                            visitar(item.id);
                          }
                        }}
                      >
                        <IconRoute />
                        <p className="label">Roteirização</p>
                      </div>
                    )}

                  <Link
                    className="card-button"
                    to={
                      item.clienteProspect
                        ? `${initialPath}/carteira/prospect/${item.id}`
                        : item.recebedor
                          ? `${initialPath}/carteira/recebedor/${item.id}`
                          : `${initialPath}/carteira/emissor/${item.id}`
                    }
                  >
                    <SearchEdit />
                    <p className="label">Editar</p>
                  </Link>
                </div>
              </div>
            ))
          )}

          {isQueryPending && (clientes || []).length > 0 && <Loader />}

          {!isLoading &&
            !isQueryPending &&
            clientes &&
            (clientes || []).length >= total &&
            !(clientes && total === 0 && (value || "").length > 0) && (
              <>
                <div className="text-center mt-8 mb-8 text-xl font-bold ">Fim da Listagem</div>
                <button className="voltar-ao-topo" onClick={() => scrollToTop()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#ffff" viewBox="0 0 24 24">
                    <path d="M12.068.016l-3.717 3.698 5.263 5.286h-13.614v6h13.614l-5.295 5.317 3.718 3.699 11.963-12.016z" />
                  </svg>
                </button>
              </>
            )}

          {(modalOpen || modalResponse) && (
            <WalletVisitModals
              modalOpen={modalOpen}
              modalResponse={modalResponse}
              idClient={idClient}
              setLoading={setLoading}
              closeModal={closedModal}
              closeResponse={() => setModalResponse(false)}
            />
          )}
        </div>
      </InfiniteScroll>
    </>
  );
};

export default SearchList;
